import { render } from "./GroupMembership.vue?vue&type=template&id=7ffc8306"
import script from "./GroupMembership.vue?vue&type=script&lang=js"
export * from "./GroupMembership.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__